module.exports = __webpack_public_path__ + "static/media/privacy.3a44365f.jpg";